'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useReducer } from 'react';
import { reducer } from './reducer';
import initialState from './state';
import { CLEAR_ALERTS, PUSH_ALERT, REMOVE_ALERT } from './actions';
export const AlertContext = createContext({
    pushAlert: (alert) => { },
    removeAlert: (id) => { },
    clearAlerts: () => { },
    useAlertState: () => Object.freeze(initialState),
    useAlerts: (placement) => []
});
export const AlertProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const useAlertState = () => {
        return state;
    };
    const useAlerts = (placement = '') => {
        if (!placement) {
            return state.alerts;
        }
        return state.alerts.filter((alert) => alert.placement === placement);
    };
    return (_jsx(AlertContext.Provider, { value: {
            useAlertState,
            useAlerts,
            pushAlert: (alert) => dispatch({ type: PUSH_ALERT, payload: alert }),
            removeAlert: (id) => dispatch({ type: REMOVE_ALERT, payload: id }),
            clearAlerts: () => dispatch({ type: CLEAR_ALERTS })
        }, children: children }));
};
